import CellDate from '@/components/GokuDataGrid/CellDate'
import CellPreview from '@/components/GokuDataGrid/CellPreview'
import { createContractUpdate } from '@/modules/Contract/modules/Updates/services'
import { Attachment } from '@/modules/Upload/types'
import { t } from 'i18next'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'

export const onPreview = async (contractID: number, description: string) => {
    await createContractUpdate({
        contractID: contractID,
        data: {
            contract_update_type: 'VIEW',
            contract_update_description: description,
        },
    })
}

export const AttachmentColumns: (
    handlePreview: (attachment: Attachment) => void
) => GridColDefVNW<Attachment>[] = (handlePreview) => [
    {
        field: 'attachment_file_name',
        headerName: t('attachment_file_name'),
        width: 500,
        renderCell: ({ row }) => (
            <CellPreview
                attachment={row}
                onPreview={() => handlePreview(row)}
            />
        ),
    },
    {
        field: 'attachment_file_size',
        headerName: t('attachment_file_size'),
        width: 150,
    },
    {
        field: 'created_at',
        headerName: t('created_at'),
        width: 150,
        renderCell: ({ value }) => (
            <CellDate date={value} scope="DD/MM/YYYY HH:mm" />
        ),
    },
]
